import { useEffect } from 'react'

// Shown instead of the app on the pre-rebrand address, once oldAddressMove has
// decided this phone may go (src/lib/oldAddressMove.ts). Short on purpose: it
// is read once, often on a phone, by people for whom English is a second
// language. Moves on its own after a few seconds; the button skips the wait.
const MOVE_AFTER_MS = 5000

export default function OldAddressNotice({ target }: { target: string }) {
  useEffect(() => {
    const t = window.setTimeout(() => window.location.replace(target), MOVE_AFTER_MS)
    return () => window.clearTimeout(t)
  }, [target])

  return (
    <main className="min-h-dvh flex items-center justify-center bg-canvas text-fg px-4">
      <div className="max-w-md w-full space-y-4">
        <h1 className="text-xl font-semibold">BigAgri has a new address</h1>
        <p>This app now lives at <strong>bigagri.app</strong>. Taking you there now.</p>
        <p>Sign in once on the new address. Nothing is waiting to upload on this phone, so no work is lost.</p>
        <p className="text-sm text-fg-muted">
          Do you open the app from an icon on your home screen? Add bigagri.app to your home screen. Then remove the old icon.
        </p>
        <a
          href={target}
          onClick={e => { e.preventDefault(); window.location.replace(target) }}
          className="inline-flex items-center justify-center min-h-[44px] px-4 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white font-medium">
          Go to bigagri.app now
        </a>
      </div>
    </main>
  )
}
